import React, { createContext, useContext, useEffect } from 'react'
import { useLocalStorage } from '../customHooks/useLocalStorage'
import en from './locales/en'
import es from './locales/es'
import de from './locales/de'
import fr from './locales/fr'
import it from './locales/it'

export const DEFAULT_LANGUAGE = 'en'

export const LANGUAGES = [
    { code: 'en', name: 'English' },
    { code: 'es', name: 'Español' },
    { code: 'de', name: 'Deutsch' },
    { code: 'fr', name: 'Français' },
    { code: 'it', name: 'Italiano' },
]

const translations = { en, es, de, fr, it }

const lookup = (dict, key) => key.split('.').reduce((acc, part) => (acc == null ? acc : acc[part]), dict)

const LanguageContext = createContext(null)

// Keeps the selected language (persisted per browser, English by default) and exposes
// t('section.key'), which falls back to English if a key is missing in a translation.
export const LanguageProvider = ({ children }) => {
    const [stored, setLang] = useLocalStorage('language', DEFAULT_LANGUAGE)
    const lang = translations[stored] ? stored : DEFAULT_LANGUAGE

    useEffect(() => {
        document.documentElement.lang = lang
    }, [lang])

    const t = (key) => lookup(translations[lang], key) ?? lookup(translations[DEFAULT_LANGUAGE], key) ?? key

    return (
        <LanguageContext.Provider value={{ lang, setLang, t }}>
            {children}
        </LanguageContext.Provider>
    )
}

export const useTranslation = () => useContext(LanguageContext)
